/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.intent

import kotlinx.browser.window

actual class WhatsAppLauncher {
    actual suspend fun launch(phoneE164: String, message: String): Boolean {
        // IMPORTANT: must be called synchronously from the click event frame,
        // otherwise browser popup blockers will prevent the open.
        val handle = window.open(buildWhatsAppUrl(phoneE164, message), "_blank")
        return handle != null
    }
}
